import { schema } from "normalizr";
import { ItemSchema } from "./item";

export const ItemsSchema = new schema.Array(ItemSchema);
